<template>
  <div class="sy-drop-down">
    <read-text v-if='isPureText' :value='pureText'></read-text>
    <filterSelect v-else v-on="$listeners" v-bind="{ ...$props, ...$attrs }" :filterPlaceholder="placeholder">
    </filterSelect>
  </div>
</template>

<style lang="scss">
  .sy-drop-down {
    .el-select {
      width: 100%;
    }

    .sy-select {
      display: block;
    }
  }
</style>

<script>
  import {dropDownProps, initValue} from './index.js'
  import filterSelect from '../../../../../basis/filter-select/index.vue'

  export default {
    name: 'drop-down',
    model: {
      event: 'change',
      prop: 'value'
    },
    props: dropDownProps,
    computed: {
      pureText () {
        return this.isPureText ? initValue(this.value) : this.value
      }
    },
    watch: {
      value: {
        handler () {
          this.$nextTick(() => {
            this.$emit('validateField', this.apiName)
          })
        }
      }
    },
    components: {
      filterSelect
    }
  }
</script>
